"use strict";

import Vue from 'vue';
import axios from "axios";
import { LoadingBar } from "view-design";
import { MessageBox } from 'element-ui';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
    // 生产环境设置baseURL，开发环境使用proxy
    baseURL: process.env.NODE_ENV === 'production'
        ? '/'
        : ''
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    LoadingBar.start()
    let accessToken = window.localStorage.getItem("accessToken");
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
}, function (error) {
    // Do something with request error
    LoadingBar.finish();
    return Promise.reject(error);
});

// Add a response interceptor
_axios.interceptors.response.use(function (response) {
    // Do something with response data
    LoadingBar.finish();
    return response;
}, function (error) {
    // Do something with response error
    LoadingBar.finish();
    if (error.response && error.response.status === 401) {
        MessageBox.confirm("登录响应超时,是否需要重新登录?", '提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            window.location.href = '/';
        }).catch(() => {

        });
    }

    return Promise.reject(error);
});

Plugin.install = function (Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        }, $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
